import {
    createContext,
    type Dispatch,
    type SetStateAction,
    useContext,
} from "react";

type DashboardTitleStateContext = [string, Dispatch<SetStateAction<string>>];

const DashboardTitleStateContext = createContext<DashboardTitleStateContext>([
    "",
    () => undefined,
]);
const DashboardTitleStateProvider = DashboardTitleStateContext.Provider;
const useDashboardTitleStateContext = () =>
    useContext(DashboardTitleStateContext);

export {
    DashboardTitleStateContext,
    DashboardTitleStateProvider,
    useDashboardTitleStateContext,
};
